import React, { useState, useRef } from "react";
import { Moment } from "moment";

import "./ProgressBar.css";
import Draggable2 from "../common/Draggable2";
import Tooltip from "../common/Tooltip";

interface Props {
    className: string;
    from: Moment;
    to: Moment;
    currentTime: Moment;
    isPlaying: boolean;
    timeUpdated: (newTime: Moment) => void;
}

const PlayControls: React.FC<Props> = function ({ className, from, to, currentTime, isPlaying, timeUpdated }: Props) {
    const barRef = useRef<HTMLDivElement>(null);
    const [draggingX, setDraggingX] = useState<number>();

    const getBoundingRect = (): DOMRect | null => (barRef.current ? barRef.current.getBoundingClientRect() : null);
    const boundingRect = getBoundingRect();

    const handleDragStart = ({ clientX }: any): void => {
        setDraggingX(clientX);
    };

    const handleDragEnd = (): void => {
        if (draggingX) {
            timeUpdated(dateFromPosition(draggingX));
        }
        setDraggingX(undefined);
    };

    const handleDrag = ({ clientX }: any): void => {
        setDraggingX(clientX);
    };

    const position = currentTime.diff(from) / to.diff(from);

    const dateFromPosition = (clientX: number): Moment => {
        if (barRef.current) {
            const boundingRect = getBoundingRect();
            const position = (clientX - boundingRect!.x) / boundingRect!.width;
            return from.clone().add(position * to.diff(from), "ms");
        } else {
            return from;
        }
    };

    return (
        <div
            ref={barRef}
            className={`${className} progress_bar ${isPlaying ? "playing" : ""}`}
            onClick={(e): void => {
                e.preventDefault();
                timeUpdated(dateFromPosition(e.clientX));
            }}
        >
            <div className="progress_bar__background" />
            <div
                className="progress_bar__cover"
                style={{ left: `${position * 100}%`, width: `${(1.0 - position) * 100}%` }}
            />
            <div className="progress_bar__container">
                <div className="bar" style={{ width: `${position * 100}%` }}>
                    <div className="marker" />
                    <Draggable2
                        onlyX
                        bounceBack
                        onDragStart={handleDragStart}
                        onDragEnd={handleDragEnd}
                        onDrag={handleDrag}
                        minX={boundingRect ? boundingRect.left : 0}
                        maxX={boundingRect ? boundingRect.right : 0}
                    >
                        <div className="marker tooltip">
                            {draggingX !== undefined ? (
                                <Tooltip visible text={`${dateFromPosition(draggingX).format("llll")}`}></Tooltip>
                            ) : null}
                        </div>
                    </Draggable2>
                </div>
            </div>
        </div>
    );
};

export default PlayControls;
